import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'chameleon/ui-stack/ui/base/icon';

export const StudentDetails = ({
  firstName,
  lastName,
  watchedPercentage,
  showWatchedPercentage,
}) => {
  return (
    <li className="flex justify-between text-14 font-normal">
      {`${firstName} ${lastName}`}
      {showWatchedPercentage && <span>{`${watchedPercentage}%`}</span>}
    </li>
  );
};
StudentDetails.displayName = 'StudentDetails';
StudentDetails.defaultProps = {
  showWatchedPercentage: false,
};
StudentDetails.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  watchedPercentage: PropTypes.number.isRequired,
  showWatchedPercentage: PropTypes.bool,
};

export const StudentWatchedPercentageDetails = (props) => {
  const { children, userNumber, progressType, classNames } = props;
  return (
    <div className="grid gap-y-2 auto-rows-min">
      <span className="grid grid-flow-col auto-cols-min gap-x-2 item-center text-14">
        <Icon id="person" width="15" height="15" />
        {userNumber}
      </span>
      <span
        className={`flex justify-center items-center text-14 h-14 rounded-md ${classNames}`}
      >
        {progressType}
      </span>
      <ul className="grid gap-y-4 auto-rows-min h-60 overflow-y-auto p-0 m-0 mt-2">
        {children}
      </ul>
    </div>
  );
};

StudentWatchedPercentageDetails.displayName = 'StudentWatchedPercentageDetails';
StudentWatchedPercentageDetails.defaultProps = {
  children: null,
  classNames: '',
};
StudentWatchedPercentageDetails.propTypes = {
  children: PropTypes.node,
  userNumber: PropTypes.number.isRequired,
  progressType: PropTypes.string.isRequired,
  classNames: PropTypes.string,
};
